import { ResourceType } from '../types/resource';
/**
 * DO NOT USE THIS FOR ANYTHING OTHER THAN RENDERING THE SYMBOL
 * @deprecated not actually deprecated but you don't need this
 */ export function getUserSymbol({ type, isGroup: userIsGroup }) {
    return userIsGroup ? 'group' : type;
}
/** Returns true if (gr)user is a group */ export function isGroup(user) {
    var _user_isGroup;
    return (_user_isGroup = user === null || user === void 0 ? void 0 : user.isGroup) !== null && _user_isGroup !== void 0 ? _user_isGroup : false;
}
export const getIsGroup = isGroup;
/** Returns group or user type id based on given gruser */ export function getUserTypeId(user) {
    return isGroup(user) ? ResourceType.GROUP : ResourceType.USER;
}
export function getUserAvatarSrc(user) {
    if (!user) {
        return null;
    }
    if (user.usericonDefault || !user.usericon) {
        return null;
    }
    return user.usericon;
}

//# sourceMappingURL=helpers.js.map